exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter{opacity:0}.slide-enter-active{animation:slide-in ease-out .2s;transition:opacity .2s}.slide-leave-active{animation:slide-out ease-in .2s forwards;transition:opacity.2s;opacity:0}@keyframes slide-in{0%{transform:translateX(500px)}to{transform:translateX(0)}}@keyframes slide-out{0%{transform:translateX(0)}to{transform:translateX(-500px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5692547d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 22
// module chunks = 0